// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".hide[data-v-63b39d9c]{position:absolute;top:0;right:0;min-width:100%;min-height:100%;filter:alpha(opacity=0);opacity:0;cursor:inherit;display:none}.uploadimgicon[data-v-63b39d9c]{width:15px;height:15px;cursor:pointer}", ""]);
// Exports
module.exports = exports;
